// React import not needed with React 19+ JSX transform
import { Textarea } from "@/components/ui/textarea";
import type { FieldConfig } from "../types";

interface TextAreaFieldProps<T> {
  field: FieldConfig<T>;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  disabled?: boolean;
  id: string;
  placeholder?: string;
  "aria-describedby"?: string;
  "aria-invalid"?: boolean;
}

export function TextAreaField<T>({
  field,
  value,
  onChange,
  onBlur,
  disabled,
  id,
  placeholder,
  "aria-describedby": ariaDescribedBy,
  "aria-invalid": ariaInvalid,
}: TextAreaFieldProps<T>) {
  return (
    <Textarea
      id={id}
      placeholder={placeholder}
      disabled={disabled}
      aria-describedby={ariaDescribedBy}
      aria-required={field.required || undefined}
      aria-invalid={ariaInvalid}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
    />
  );
}
